import React from 'react';
import { Navigate ,useParams} from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';
import { useNavigate } from 'react-router-dom'
const AdminProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { tenant } = useParams();
  const navigate = useNavigate();
  console.log(tenant);
  console.log(globalThis.localStorage.getItem('tenant'));
  console.log(tenant==globalThis.localStorage.getItem('tenant'));
  if(tenant!=globalThis.localStorage.getItem('tenant'))
  {
navigate('/not-found');
  }
  if (tenant!=globalThis.localStorage.getItem('tenant') || !user || globalThis.localStorage.getItem(`accessToken_${tenant}`)==null ) {
    // Rediriger vers la page de login si l'utilisateur n'est pas authentifié
    return <Navigate to="/" />;
  }

  if (user.id_service !== 0 &&( user.access_level !== 0 && user.access_level !== 1)) {
    return <Navigate to="/not-found" />;
  }

  // Rendre le composant enfant si l'utilisateur est un admin
  return children;
};

export default AdminProtectedRoute;
